var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000488281,
    y: 0.00292969,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#6F767E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0752 7.04502C10.8055 7.47463 10.8055 8.53081 10.0752 8.96043L7.08145 10.7214C6.34075 11.1572 5.40698 10.6231 5.40698 9.76374V6.2417C5.40698 5.38235 6.34075 4.84829 7.08145 5.284L10.0752 7.04502Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.d051ac993cea202566f984433263a8f5.svg";
export { ForwardRef as ReactComponent };